import { render, staticRenderFns } from "./ac-notifications.vue?vue&type=template&id=aeea8dee&scoped=true&"
import script from "./ac-notifications.vue?vue&type=script&lang=js&"
export * from "./ac-notifications.vue?vue&type=script&lang=js&"
import style0 from "./ac-notifications.vue?vue&type=style&index=0&id=aeea8dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea8dee",
  null
  
)

export default component.exports